export default __webpack_public_path__ + "static/media/sabine-ruppert.c56ba341.jpg";